import moment from 'moment/moment'

import { CompanyEntitlementResponse } from 'types/api/companies/contracts'

/**
 * @returns the numeric difference between dateEnd and today in days
 */
export function getDaysUntilContractExpiration(
  dateEnd: string | Date,
  today?: moment.Moment | Date
) {
  const momentToday = moment.isMoment(today) ? today : moment(today)
  const momentEndDate = moment(dateEnd)
  return momentEndDate.diff(momentToday, 'days')
}

export function getEntitlementsExpirationProperties(dateEnd: string | Date) {
  const daysUntilContractExpiration = getDaysUntilContractExpiration(dateEnd)

  return {
    contractExpirationImminent: daysUntilContractExpiration <= 7,
    daysUntilContractExpiration
  }
}

export function flattenEntitlements(entitlements: CompanyEntitlementResponse) {
  return {
    dateStart: entitlements.created_at,
    dateEnd: entitlements.end,
    isInternal: entitlements.internal,
    isStrict: entitlements.strict,
    hasAgentBilling: entitlements.has_agent_billing,
    hasTrialBanners: entitlements.has_trial_banners,
    hasProductFI: entitlements.product_flags.hasProductFI,
    hasProductRM: entitlements.product_flags.hasProductRM,
    hasProductFF: entitlements.product_flags.hasProductFF,
    limitAgents: entitlements.limits.limitAgents,
    limitServices: entitlements.limits.limitServices,
    limitTargets: entitlements.limits.limitTargets,
    limitTeams: entitlements.limits.limitTeams,
    limitUsers: entitlements.limits.limitUsers,
    targetsTrackingPeriod: entitlements.targets_tracking_period
  }
}
